import { render, staticRenderFns } from "./WV-PH-Notice.vue?vue&type=template&id=8945e0e6&scoped=true&"
import script from "./WV-PH-Notice.vue?vue&type=script&lang=js&"
export * from "./WV-PH-Notice.vue?vue&type=script&lang=js&"
import style0 from "./WV-PH-Notice.vue?vue&type=style&index=0&id=8945e0e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8945e0e6",
  null
  
)

export default component.exports